module.exports = __webpack_public_path__ + "img/2025-02-12-Raking-Sprint-MODELOS.f27b44dd.png";